import { inject, runInInjectionContext, EnvironmentInjector } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Auth, authState, signOut } from '@angular/fire/auth';
import { from, of } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';
import { AdminCheckService } from '../services/admin-check.service';

export const authGuard: CanActivateFn = () => {
  const injector = inject(EnvironmentInjector);
  const auth = inject(Auth);
  const router = inject(Router);
  const adminCheck = inject(AdminCheckService);
  return runInInjectionContext(injector, () => authState(auth)).pipe(
    take(1),
    switchMap((user) => {
      if (!user) return of(router.createUrlTree(['/login']));
      if (adminCheck.isAdmin(user.uid)) return of(true);
      return adminCheck.checkIsAdmin(user.uid).pipe(
        switchMap((isAdmin) => {
          if (isAdmin) return of(true);
          return runInInjectionContext(injector, () =>
            from(signOut(auth)).pipe(map(() => router.createUrlTree(['/login'])))
          );
        })
      );
    })
  );
};
